<template>
  <v-btn
    color="primary"
    @click="close"
    prepend-icon="mdi-arrow-left"
    class="ma-2"
    :disabled="loading"
  >
    {{ t('back') }}
  </v-btn>
  <div v-if="loading" class="grid-loading">
    <v-progress-circular indeterminate />
  </div>
  <v-expansion-panels v-else v-model="expandedTab">
    <OrgTable @clikOrg="selectOrg">
      <template v-slot:title>
        <v-btn @click.stop="selectCurrentOrg" color="primary" class="ml-2">
          {{ t('select-current-org') }}
        </v-btn>
      </template>
    </OrgTable>
    <UserTable @clickPerson="assumeUser" :selectedOrgId="selectedOrg?.orgId" />
  </v-expansion-panels>
</template>
<script setup>
import { ref, nextTick } from 'vue';
import OrgTable from './OrgTable.vue';
import UserTable from './UserTable.vue';
import { useRootStore } from '../../stores/root';
import { initSupportUser, clearSupportUser } from '../../helpers/supportUser';
import { retrieveTokensAndSetCookies } from '../../helpers/token_extraction';
import router from '../../router';
import { useI18n } from 'vue-i18n';
import { assumeDifferentUser } from '../../helpers/assumeUser';
const { t } = useI18n();

const emit = defineEmits(['close']);
const loading = ref(false);
const selectedOrg = ref();
const expandedTab = ref(0);

function selectOrg(org) {
  // console.log('selectOrg', {
  //   org,
  //   type: typeof org,
  // });
  selectedOrg.value = org;
  expandedTab.value = 1;
}

const store = useRootStore();

function selectCurrentOrg() {
  selectedOrg.value = store.user.organization;
  expandedTab.value = 1;
}

async function assumeUser(person) {
  loading.value = true;

  const orgId = selectedOrg.value.orgId;

  const userId = person.PK.replace('user-', '');

  try {
    await assumeDifferentUser(orgId, userId);
  } catch (e) {
    console.error(e);
  }

  loading.value = false;
  close();
}

function close() {
  emit('close');
}
</script>
<i18n>
{
  "en": {
    "back": "Back",
    "select-current-org": "Select Current Org"
  },
  "es": {
    "back": "Atrás",
    "select-current-org": "Seleccionar Organización Actual"
  }
}
</i18n>
<style scoped>
.grid-loading {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
